<template>
<span class="d-flex align-items-center gap-2">
	<span :class="classByState(oldState)">
		{{ capitalizeFirstLetter(ServiceUnit.boxDoorStatePromt(oldState)) }}
	</span>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="16"
		height="16"
		fill="currentColor"
		class="bi bi-arrow-right"
		style="min-width: 16px; min-height: 16px; flex-shrink: 0;"
		viewBox="0 0 16 16"
	>
		<path
			fill-rule="evenodd"
			d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"
		/>
	</svg>
	<span :class="classByState(newState)">
		{{ capitalizeFirstLetter(ServiceUnit.boxDoorStatePromt(newState)) }}
	</span>
</span>
</template>



<script>
import { capitalizeFirstLetter } from '@/helpers.js'
import { eventSchema } from '@/composables/events.js'
import { ServiceUnit } from '@/models/serviceUnit.js'


export default {
	components: {},
	
	props: {
		[eventSchema.payload.allowed.boxBoorState.key]: {
			type: Object, // { old: Number, new: Number }
			required: true,
		},
	},

	setup() {
		return {
			capitalizeFirstLetter,
			eventSchema,
			ServiceUnit,
		}
	},

	methods: {
		classByState(state) {
			return {
				'text-success': state == ServiceUnit.boxDoorStateCodes.close,
				'text-warning': state == ServiceUnit.boxDoorStateCodes.open,
				'text-danger': state == ServiceUnit.boxDoorStateCodes.short,
			}
		},
	},

	computed: {
		oldState() {
			return this.$props[eventSchema.payload.allowed.boxBoorState.key].old
		},

		newState() {
			return this.$props[eventSchema.payload.allowed.boxBoorState.key].new
		},
	},
}
</script>